import dayjs from 'dayjs';

const plural = (count: number, unit: string) => (count === 1 ? `1 ${unit} ago` : `${count} ${unit}s ago`);

/**
 * The Buddy relative date/time format: "just now", "a minute ago", "5 minutes ago",
 * "1 hour ago", "yesterday at 15:05", "3 days ago", "1 week ago", "2 months ago", "1 year ago".
 * Not dayjs' fromNow, which says "a few seconds ago" / "a day ago" and skips weeks.
 */
export const formatRelativeTime = (date: Date, now: Date = new Date()): string => {
  const then = dayjs(date);
  const current = dayjs(now);
  const minutes = current.diff(then, 'minute');

  if (minutes < 1) return 'just now';

  if (minutes < 2) return 'a minute ago';

  if (minutes < 60) return `${minutes} minutes ago`;

  if (then.isSame(current, 'day')) return plural(current.diff(then, 'hour'), 'hour');

  if (then.isSame(current.subtract(1, 'day'), 'day')) return `yesterday at ${then.format('HH:mm')}`;

  const days = current.startOf('day').diff(then.startOf('day'), 'day');

  if (days < 7) return `${days} days ago`;

  if (days < 28) return plural(Math.floor(days / 7), 'week');

  const months = current.diff(then, 'month');

  if (months < 12) return plural(Math.max(months, 1), 'month');

  return plural(current.diff(then, 'year'), 'year');
};
